import styled from 'styled-components';
import { Box, Button } from '@rsos/base-components';

export const Container = styled(Box).attrs({
  backgroundColor: 'background',
  borderRadius: '5px',
})`
  overflow: hidden;
  min-width: 350px;
`;

export const Header = styled(Box).attrs({
  align: 'center',
  justify: 'space-between',
  padding: '8px 12px',
  backgroundColor: 'background',
  borderBottom: '1px solid',
  borderColor: 'lightLineDivider',
})``;

export const Dropdown = styled.select`
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
`;

export const ToggleButton = styled(Button).attrs({
  btnType: 'invisible',
  size: 'xsmall',
  p: 0,
})`
  cursor: pointer;
`;

export const Content = styled(Box)<{ $isExpanded: boolean }>`
  transition: all 0.3s ease;
  overflow: hidden;
  height: ${({ $isExpanded }) => ($isExpanded ? 'auto' : '0')};
  opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
`;
